import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import { isValidElement } from "../../util/ApiHelper";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

const SidebarLogo = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { width, themeType } = useSelector(({ settings }) => settings);
  const userData = useSelector(({ auth }) => auth?.userData);
  const token = JSON.parse(localStorage.getItem("token"));
  const {isMobile} = useGetBreakpoints();
  let isLoggedIn = userData?.id && isValidElement(token) ? true : false;
  let navStyle = useSelector(({ settings }) => settings.navStyle);
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }
  return (
    <div className="gx-layout-sider-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      {isLoggedIn &&
      (navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) ? (
        <div className="gx-linebar">
          <i
            className={`gx-icon-btn icon icon-${
              !sidebarCollapsed ? "menu-unfold" : "menu-fold"
            } ${themeType !== THEME_TYPE_LITE ? "gx-text-white" : ""}`}
            onClick={() => {
              setSidebarCollapsed(!sidebarCollapsed);
            }}
          />
        </div>
      ) : null}

      <Link to="/" className="gx-site-logo myexim-logo" style={{ display: "flex", alignItems: "left",marginRight: "10px" }}>
        {navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR && width >= TAB_SIZE ? (
          <img
            alt="lo"
            src={"/assets/images/logo.svg"}
            height={36}
          />
        ) : themeType === THEME_TYPE_LITE ? (
          <img
            alt="logo1"
            src={"/assets/images/logo.svg"}
            height={36}
          />
        ) : (
          <img
            alt="logo2"
            src={"/assets/images/logo.svg"}
            height={36}
          />
        )}
      </Link>


      {!isLoggedIn && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px" }}>
          <a
            href="mailto:contactus@myeximbusiness.com"
            className="gx-pl-2 gx-px-2"
            onClick={(e) => e.stopPropagation()}
            style={{
              fontWeight: 500,
              fontSize: 16,
              margin: 6,
              color: "#999",
            }}
          >
            <MailOutlined style={{ fontSize: "18px", color: "#1890ff", marginRight:"4px" }} />
            {!isMobile && "contactus@myeximbusiness.com"}
          </a>

          <a
            href="tel:+919994407890"
            onClick={(e) => e.stopPropagation()} 
            className="gx-pl-2 gx-px-2"
            style={{
              fontWeight: 500,
              fontSize: 16,
              margin: 6,
              color: "#999",
            }}
          >
            <PhoneOutlined style={{ fontSize: "18px", color: "#52c41a", marginRight:"4px" }} />
            {!isMobile && "+91 9994407890"}
          </a>
        </div>
      )}
      
    </div>
  );
};

export default SidebarLogo;
